// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bc_fc","conditions__content":"bc_fd","conditions__footer":"bc_ff"};